export const personal_info={
    mobile:"+91 9000160490",
    email:"info@eushetty.in",
    whatsappLink:"https://wa.me/+919000160490",
    twitterLink:"https://x.com/eushettyspeaker",
    instagramLink:"https://www.instagram.com/eushetty_official",
    youtubeChannel:"https://www.youtube.com/@eushettyspeaker",
    facebookLink:"https://www.facebook.com/eushettyspeaker",
    embedVideo:"https://www.youtube.com/embed/FQUiuYBmpCA?si=KPjZtL6QxHMf9pSc"

    

}